import { useState, useEffect } from 'react';
//import { mapboxgl } from '../utils/mapboxConfig';
import { useToast } from '@/hooks/use-toast';
import { Point } from '@/lib/types/core';

interface UseGeolocationRideFilteringProps {
    setNearbyPoint: (point: Point) => void;
}

export const useGeolocationRideFiltering = ({ setNearbyPoint }: UseGeolocationRideFilteringProps) => {
    const [isLocating, setIsLocating] = useState(false);
    const { toast } = useToast();
    
    useEffect(() => {
        // Wait for component to mount before executing geolocation
        if ('geolocation' in navigator) {
            setIsLocating(true);

            navigator.geolocation.getCurrentPosition((position) => {
                const { longitude, latitude } = position.coords;
                setNearbyPoint({
                    longitude: longitude,
                    latitude: latitude
                });
                
                setIsLocating(false);
            },
            (error) => {
                console.error('Geolocation error:', error);
                setNearbyPoint({
                    longitude: -98.5795,
                    latitude: 39.8283,
                });
                setIsLocating(false);
            },
            {
                enableHighAccuracy: false,
                timeout: 5000,
                maximumAge: 300000
            }
            );
        } else {
            toast({
                title: "Location not supported",
                description: "Your browser doesn't support geolocation.",
                variant: "destructive"
            });
            setIsLocating(false);
        }
    }, []); // Empty dependency array ensures this runs only once after mount
  
    return { isLocating };
};
